import { Group, Title } from '@mantine/core';
import React from 'react';
import DataTable from 'react-data-table-component';
import useGetMatch from './useMatch';
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';
import UserRow from './components/UserRow';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';


dayjs.extend(utc);
dayjs.extend(timezone);


const Remote = () => {

    const { MatchQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch
    } = useGetMatch()


    const columns = [

        {
            name: 'User Name',
            selector: row => row.user.tiktok_username,
            //sortable: true,
            cell: row => <UserRow row={row.user} />,

        },
        {
            name: 'Opponent Name',
            selector: row => row.opponent.tiktok_username,
            //sortable: true,
            cell: row => <UserRow row={row.opponent} />,

        },
        {
            name: 'Match Style',
            selector: row => row.match_style ? row.match_style?.name : 'N/A',
            // sortable: true,
        },
        {
            name: 'Is More Visible',
            selector: row => row.is_more_visible ? 'Yes' : 'No',
            sortable: true,
        },

        {
            name: 'Match Time',
            selector: row => {
                // Parse the UTC time and convert to local time
                const localTime = dayjs.utc(row.match_confirm_time).local().format('D MMM YYYY, HH:mm:ss');
                return localTime;
            },
            sortable: true,
        },

    ];





    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Confirmed Matches</Title>


            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}



            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
